import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { VisionSection } from '../components/VisionSection';
import { VenturesGrid } from '../components/VenturesGrid';
import { TeamSection } from '../components/TeamSection';
import { Footer } from '../components/Footer';
import { FloatingNav } from '../components/ui/FloatingNav';
export function LandingPage() {
  return <div className="min-h-screen bg-deep-dark text-white overflow-x-hidden pt-16 md:pt-0" data-id="element-239">
      <FloatingNav data-id="element-240" />
      <HeroSection data-id="element-241" />
      <VisionSection data-id="element-242" />
      <VenturesGrid data-id="element-243" />
      <TeamSection data-id="element-244" />
      <Footer data-id="element-245" />
    </div>;
}